import { render } from "./FpIcon.vue?vue&type=template&id=b2f031d8"
import script from "./FpIcon.vue?vue&type=script&lang=js"
export * from "./FpIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__